import { Camera, CheckCircle2, MessageCircleMore } from "lucide-react";
import { Link } from "react-router";
import { Card } from "@contractor-quoting/shared-ui";

interface UploadedImage {
  id: string;
  filename: string;
}

export function QuoteSidebar({
  contractorSlug,
  images,
  onUpload,
}: {
  contractorSlug: string;
  images: UploadedImage[];
  onUpload: (file: File) => void;
}) {
  return (
    <aside className="sticky top-5">
      <Card>
        <MessageCircleMore className="text-emerald-800" />
        <h2 className="mt-4 text-lg font-bold text-emerald-950">Need the project guide?</h2>
        <p className="mt-2 text-sm leading-6 text-stone-600">
          Return to the full conversation without losing the structured details saved here.
        </p>
        <Link
          className="mt-5 flex min-h-11 items-center justify-center rounded-xl bg-emerald-800 px-4 font-semibold text-white transition hover:bg-emerald-900"
          to={`/chat/${contractorSlug}`}
        >
          Return to chat
        </Link>
      </Card>
      <Card className="mt-4">
        <div className="flex gap-3">
          <Camera className="text-emerald-800" />
          <div>
            <h3 className="font-bold">Reference photos</h3>
            <p className="text-sm text-stone-600">
              Private and shown only to you and the contractor. Images are never sent to the agent.
            </p>
          </div>
        </div>
        <label className="mt-4 block cursor-pointer rounded-xl border border-dashed border-emerald-300 p-4 text-center font-semibold text-emerald-900">
          Choose image
          <input
            className="sr-only"
            type="file"
            accept="image/jpeg,image/png,image/webp"
            onChange={(event) => {
              const file = event.target.files?.[0];
              if (file) onUpload(file);
            }}
          />
        </label>
        {images.map((image) => (
          <div
            className="mt-3 flex items-center justify-between rounded-lg bg-stone-100 p-3 text-sm"
            key={image.id}
          >
            <span>{image.filename}</span>
            <CheckCircle2 size={17} className="text-emerald-700" />
          </div>
        ))}
      </Card>
    </aside>
  );
}
